import { render } from "./InstallationDescription.vue?vue&type=template&id=f807cbfc&scoped=true"
import script from "./InstallationDescription.vue?vue&type=script&lang=js"
export * from "./InstallationDescription.vue?vue&type=script&lang=js"

import "./InstallationDescription.vue?vue&type=style&index=0&id=f807cbfc&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f807cbfc"]])

export default __exports__